import { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';

import MetadataInfo from '../MetadataInfo/MetadataInfo';

import classes from './MetadataByCampus.module.css';

const MetadataByCampus = props => {
  const [editMetadata, setEditMetadata] = useState(false);

  const editMetadataHandler = () => {
    setEditMetadata(!editMetadata);
  };

  return (
    <div className={classes.campusContainer}>
      <p className={classes.campusTitle}>{props.campus}</p>
      <Button
        className={classes.editMetadataBtn}
        onClick={editMetadataHandler}
      >
        Editar
      </Button>
      <aside className={classes.infoContainer}>
        {props.userMetadata.map(
          metadata =>
            props.campus === metadata.academies && (
              <MetadataInfo
                metadata={metadata}
                key={`${props.campus}_${metadata.name}`}
                edit={editMetadata}
                newMetadataHandler={props.newMetadataHandler}
              />
            )
        )}
      </aside>
    </div>
  );
};

MetadataByCampus.propTypes = {
  // eslint-disable-next-line react/require-default-props
  campus: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  userMetadata: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  newMetadataHandler: PropTypes.func
};

export default MetadataByCampus;
